import React from 'react';
import { FormGroup } from 'reactstrap';

import DBAliasModal from './DBAliasModal';

import WarnButton from '../components/WarnButton';
import { InputField, RHFField, rfRules } from '../../../../../components/Field';
import { required } from '../../../../../components/Field/validate';

// Migrated to react-hook-form: registers the read-only `dbAlias` field on the parent
// SyncForm's `control`; the modal sets it via the parent's setValue (onDatabaseIDSelect).
function DatabaseIDSelect({ control, storeId, protocol, hostName, port, onDatabaseIDSelect }) {
  const [open, setOpen] = React.useState(false);

  function toggle() {
    setOpen(!open);
  }

  function handleSelect(value) {
    toggle();
    onDatabaseIDSelect(value);
  }

  return (
    <React.Fragment>
      <FormGroup className="col-sm-12 col-xs-12 col-md-9 col-lg-9" style={{ marginBottom: 'none' }}>
        <RHFField name="dbAlias" control={control} component={InputField} type="text" id="dbAlias" readOnly rules={rfRules([required])} />
      </FormGroup>
      <FormGroup className="col-sm-12 col-xs-12 col-md-3 col-lg-3" style={{ marginBottom: 'none' }}>
        <WarnButton
          id="DbAliasBtn"
          hasWarn={!hostName || !protocol || !port}
          warningText="Please fill 'Connection' fields above"
          onClick={toggle}
        />
      </FormGroup>

      <DBAliasModal
        isOpen={open}
        storeId={storeId}
        protocol={protocol}
        hostName={hostName}
        port={port}
        onSelect={handleSelect}
        onCancel={toggle}
      />
    </React.Fragment>
  );
}

export default DatabaseIDSelect;
